import { Flex, Image, Text } from '@chakra-ui/react';
import { forwardRef } from 'react';

interface OptionWrapperProps {
  imageSrc: string;
  label: string;
  isActive?: boolean;
  onClick?: () => void;
  testId?: string;
}

/**
 * OPTION WRAPPER
 *
 * Renders the option button with an image and label for the interactive menu.
 */
export const OptionWrapper = forwardRef<any, OptionWrapperProps>(
  ({ imageSrc, label, onClick, testId, isActive }, ref) => {
    return (
      <Flex
        ref={ref}
        onClick={onClick}
        direction='column'
        border='1px solid'
        borderColor={isActive ? 'upgrade.blue.500' : 'gray.100'}
        bg={isActive ? 'hover.blue' : 'white'}
        justifyContent='center'
        alignItems='center'
        as='button'
        textAlign='center'
        p={2}
        _hover={{ bg: 'hover.gray' }}
        borderRadius='base'
        w='full'
        data-testid={testId}
        role='presentation'
      >
        <Image src={imageSrc} alt='' w='auto' h='86px' draggable={false} />
        <Text fontSize='xs'>{label}</Text>
      </Flex>
    );
  },
);

OptionWrapper.displayName = 'OptionWrapper';
